let inject = ['$scope', '$uibModalInstance'];

class OfflineModalController {
  constructor ($scope,$uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.user = {};
  }
  
  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
  
  selectThird() {
    this.$uibModalInstance.close(this.user);
  }
}

OfflineModalController.$inject = inject;

export default OfflineModalController ;



// WEBPACK FOOTER //
// ./www/components/shared/components/offline-modal/offline-modal.controller.js